// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2oiWQ","title":"Images45_title__2_jDc","images":"Images45_images__QESDF"};